import React from 'react';
import { Check } from '../../../../icons/BusinessType/Check';
var BusinessOptionCard = function (_a) {
    var icon = _a.icon, text = _a.text, selected = _a.selected, disabled = _a.disabled, onClick = _a.onClick;
    return (React.createElement("div", { className: "relative flex flex-col items-center justify-center border rounded-2xl p-6 cursor-pointer transition-all\n        ".concat(disabled
            ? 'cursor-auto opacity-50 border-[#E9EDF7]'
            : selected
                ? 'border-primary border-2'
                : 'border-[#E9EDF7] hover:shadow-md', "\n      "), onClick: !disabled ? onClick : undefined },
        React.createElement("div", { className: "text-4xl mb-3" }, icon),
        React.createElement("div", { className: "text-center text-lg font-medium" }, text),
        selected && (React.createElement("div", { className: "absolute top-3 right-3 bg-primary text-white rounded-[4px] p-[2px]" },
            React.createElement(Check, null)))));
};
export default BusinessOptionCard;
